import { PatientsPageV2 } from "../../../ui/pages/v2/PatientsPage";

export function PatientsV2Route() {
  return <PatientsPageV2 />;
}
